export const projectsData = [
  {
    id: 1,
    title: 'Fainex lux Aer Resort',
    category: 'Luxury Home stay',
    location: 'Vagamon',
    year: '2023',
    image: '/images/projects/finex/fainex-lux-aer.jpeg',
    description: 'A Luxury Home stay in Vagamon suspended in the clouds, featuring infinity pools, spa, and panoramic valley views. Perfect for those seeking tranquility and luxury amidst nature.',
    features: [
      'Car parking',
      'Swimming Pool',
      'Indoor games',
      'Fine Dining',
      'Valley Views'
    ],
    galleryImages: [
      {
        id: 1,
        title: 'Main Entrance',
        category: 'outdoor',
        image: '/images/projects/finex/pool1.jpeg',
        type: 'Swimming Pool'
      },
      {
        id: 2,
        title: 'Infinity Pool',
        category: 'outdoor',
        image: '/images/projects/finex/pool2.jpeg',
        type: 'Infinity Pool'
      },
      {
        id: 3,
        title: 'Night View',
        category: 'outdoor',
        image: '/images/projects/finex/fnight.jpeg',
        // description: 'Beautifully landscaped gardens with exotic flowers and seating areas.',
        type: 'Night View'
      },
      {
        id: 4,
        title: 'Main View',
        category: 'outdoor',
        image: '/images/projects/finex/fent2.jpeg',
        // description: 'Spectacular terrace offering the best sunset views in Vagamon.',
        type: 'Main View'
      },
      {
        id: 5,
        title: 'Spa Pavilion',
        category: 'outdoor',
        image: '/images/projects/finex/fent3.jpeg',
        // description: 'Open-air spa pavilion surrounded by lush greenery and serene atmosphere.',
        type: 'Main Entrance'
      }
    ]
  },
  {
    id: 2,
    title: 'The Soul Resort',
    category: 'Boutique Resort',
    location: 'Ranch in Vagamon',
    year: '2022',
        image: '/images/projects/soul/soul3-pro.jpeg',
    description: 'An exclusive 20-acre estate with 6 pavilions, private lake, and helipad access. Experience luxury living in the heart of nature.',
    features: [
      'Mountain view',
      'Swimming Pool',
      'Private patio or balcony',
      'Parking',
      'Dedicated workspace',
      'Kitchen',
      'Back garden',
    ],
    galleryImages: [
      {
        id: 13,
        title: 'The Soul View',
        category: 'outdoor',
        image: '/images/projects/soul/soul-pro.png',
        type: 'The Soul View'
      },
      {
        id: 14,
        title: 'The Soul',
        category: 'outdoor',
        image: '/images/projects/soul/soul-day.jpeg',
        type: 'The Soul'
      },
      {
        id: 15,
        title: 'Patio',
        category: 'indoor',
        image: '/images/projects/soul/balcony.jpeg',
        type: 'Private patio',

      },
      {
        id: 16,
        title: 'Bed Room',
        category: 'indoor',
        image: '/images/projects/soul/bedroom.jpeg',
        type: 'Bed Room'
      },
      {
        id: 17,
        title: 'Dining Area',
        category: 'indoor',
        image: '/images/projects/soul/visitingarea.jpeg',
        type: 'Dining Area'
      },
      {
        id: 18,
        title: 'Washing',
        category: 'indoor',
        image: '/images/projects/soul/washbs.jpeg',
        type: 'Washing'
      }

    ]
  },
  {
    id: 3,
    title: 'The highlanders',
    category: 'Luxurious Resort',
    location: 'Vattapathal, Vagamon',
    year: '2023',
    image: '/images/projects/HL/The-highlanders.jpeg',
    description: 'A premium Vagamon retreat offering luxury stays, spa experiences, and scenic hill views. Perfect for a relaxing getaway surrounded by nature and iconic viewpoints.',
    features: [
      'Parking',
      'Indoor games',
      'Plunge pool',
      'Garden furniture',
      'Mountain Views',
      'Bathtub',
      'Private Balcony'
    ],
    galleryImages: [
      {
        id: 25,
        title: 'game',
        category: 'indoor',
        image: '/images/projects/HL/games.jpeg',
        type: 'Indoor Games'
      },
      {
        id: 26,
        title: 'Plunge Pool',
        category: 'outdoor',
        image: '/images/projects/HL/pool.jpeg',
        type: 'Plunge Pool'
      },
      {
        id: 27,
        title: 'Garden Seating',
        category: 'outdoor',
        image: '/images/projects/HL/valleyview.jpeg',
        type: 'Garden Seating'
      },
      {
        id: 28,
        title: 'Lounge',
        category: 'indoor',
        image: '/images/projects/HL/loungearea.jpeg',
        type: 'Lounge Area'
      },
      {
        id: 29,
        title: 'Bath tub',
        category: 'indoor',
        image: '/images/projects/HL/bathtubwithscenicview.jpeg',
        type: 'Bath tub with Scenic View'
      },
      {
        id: 30,
        title: 'Bedroom',
        category: 'indoor',
        image: '/images/projects/HL/bedroomwithbalcony.jpeg',
        type: 'Bedroom, Private Balcony, Pool'
      },
      {
        id: 31,
        title: 'Scenic views of misty valleys',
        category: 'outdoor',
        image: '/images/projects/HL/scenic.jpeg',
        type: 'Scenic Views of Misty Valley'
      },
      {
        id: 32,
        title: 'Bedroom Suite',
        category: 'indoor',
        image: '/images/projects/HL/bedroom.jpeg',
        type: 'Bedroom Suite'
      },
      {
        id: 33,
        title: 'Bedroom ',
        category: 'indoor',
        image: '/images/projects/HL/bedroom2.jpeg',
        type: 'Bedroom'
      },
      {
        id: 34,
        title: 'Bedroom',
        category: 'indoor',
        image: '/images/projects/HL/bedroom3.jpeg',
        type: 'Bedroom'
      },
      {
        id: 35,
        title: 'Bathroom',
        category: 'indoor',
        image: '/images/projects/HL/bathroom.jpeg',
        type: 'Bathroom'
      },
      {
        id: 36,
        title: 'Bathroom',
        category: 'indoor',
        image: '/images/projects/HL/washroom.jpeg',
        type: 'Bathroom'
      }
    ]
  },
  {
    id: 4,
    title: 'Kings landing',
    category: 'Private Luxury Boutique Villa',
    location: 'Vagamon',
    year: '2022',
    image: '/images/projects/KL/King-landing.jpeg',
    description: 'A private luxury boutique villa in Vagamon featuring valley views, an infinity pool, and curated dining. A serene hilltop retreat just 20 minutes from town, ideal for couples and families.',
    features: [
      'Infinity Pool',
      'Curated dining',
      'Valley views',
      'Private Butler'
    ],
    galleryImages: [
      {
        id: 37,
        category: 'indoor',
        image: '/images/projects/KL/1.jpeg',
      },
      {
        id: 38,
        category: 'indoor',
        image: '/images/projects/KL/2.jpeg',
      },
      {
        id: 39,
        category: 'indoor',
        image: '/images/projects/KL/3.jpeg',

      },
      {
        id: 40,
        category: 'indoor',
        image: '/images/projects/KL/4.jpeg',

      },
      {
        id: 41,
        category: 'indoor',
        image: '/images/projects/KL/5.jpeg',

      },
      // {
      //   id: 42,
      //   category: 'indoor',
      //   image: '/images/projects/KL/6.jpeg',

      // },
      {
        id: 43,
        category: 'indoor',
        image: '/images/projects/KL/7.jpeg',

      },
      {
        id: 44,
        category: 'indoor',
        image: '/images/projects/KL/8.jpeg',

      },
      {
        id: 45,
        category: 'indoor',
        image: '/images/projects/KL/9.jpeg',

      },
      {
        id: 46,
        category: 'indoor',
        image: '/images/projects/KL/10.jpeg',

      },
      {
        id: 47,
        category: 'indoor',
        image: '/images/projects/KL/11.jpeg',

      },
      {
        id: 48,
        category: 'indoor',
        image: '/images/projects/KL/12.jpeg',

      },
      {
        id: 49,
        category: 'indoor',
        image: '/images/projects/KL/13.jpeg',

      },
      {
        id: 50,
        category: 'indoor',
        image: '/images/projects/KL/14.jpeg',

      },
      // {
      //   id: 51,
      //   category: 'indoor',
      //   image: '/images/projects/KL/15.jpeg',

      // },
      {
        id: 52,
        category: 'indoor',
        image: '/images/projects/KL/16.jpeg',

      },
      {
        id: 53,
        category: 'indoor',
        image: '/images/projects/KL/17.jpeg',

      },
      {
        id: 54,
        category: 'outdoor',
        image: '/images/projects/KL/18.jpeg',

      },
      {
        id: 55,
        category: 'indoor',
        image: '/images/projects/KL/19.jpeg',

      },
      {
        id: 56,
        category: 'indoor',
        image: '/images/projects/KL/20.jpeg',

      },
      {
        id: 57,
        category: 'indoor',
        image: '/images/projects/KL/21.jpeg',

      },
      {
        id: 58,
        category: 'indoor',
        image: '/images/projects/KL/22.jpeg',

      },
      {
        id: 59,
        category: 'indoor',
        image: '/images/projects/KL/23.jpeg',

      },
      {
        id: 60,
        category: 'indoor',
        image: '/images/projects/KL/24.jpeg',

      },
      {
        id: 61,
        category: 'indoor',
        image: '/images/projects/KL/25.jpeg',

      },
      {
        id: 62,
        category: 'indoor',
        image: '/images/projects/KL/26.jpeg',

      },
      {
        id: 63,
        category: 'indoor',
        image: '/images/projects/KL/27.jpeg',

      },
      {
        id: 64,
        category: 'indoor',
        image: '/images/projects/KL/28.jpeg',

      },
      {
        id: 65,
        category: 'indoor',
        image: '/images/projects/KL/29.jpeg',

      },
      {
        id: 66,
        category: 'indoor',
        image: '/images/projects/KL/30.jpeg',

      },
      {
        id: 67,
        category: 'indoor',
        image: '/images/projects/KL/31.jpeg',

      },
      {
        id: 68,
        category: 'outdoor',
        image: '/images/projects/KL/32.jpeg',

      },
      {
        id: 69,
        category: 'indoor',
        image: '/images/projects/KL/33.jpeg',

      },
      {
        id: 70,
        category: 'indoor',
        image: '/images/projects/KL/34.jpeg',

      },
      {
        id: 71,
        category: 'indoor',
        image: '/images/projects/KL/35.jpeg',

      },
      {
        id: 72,
        category: 'indoor',
        image: '/images/projects/KL/36.jpeg',

      },
      {
        id: 73,
        category: 'indoor',
        image: '/images/projects/KL/37.jpeg',

      },
      {
        id: 74,
        category: 'indoor',
        image: '/images/projects/KL/38.jpeg',

      },
      {
        id: 75,
        category: 'indoor',
        image: '/images/projects/KL/39.jpeg',

      },
      {
        id: 76,
        category: 'indoor',
        image: '/images/projects/KL/40.jpeg',

      }
    ]
  }
];